import axios from "axios";

import { privateApi } from ".";
import { FaqCategory } from "../../models/FaqCategory";

export const faqApi = privateApi.injectEndpoints({
  endpoints: (builder) => ({
    getFaq: builder.query<FaqCategory[], void>({
      queryFn: async () => {
        const response = await axios({ url: "/locales/fr.faq.json" });
        return { data: response.data };
      },
    }),
  }),
});

export const { useGetFaqQuery } = faqApi;
